import { useContext, createContext, useState, useMemo } from 'react';

type ConfirmParams = {
  onConfirm?: () => Promise<void | unknown>;
  onCancel?: () => void;
  confirmText?: string;
  cancelText?: string;
  message: string | React.ReactNode;
  title: string;
  error?: string;
};

type ConfirmContextState = [React.Dispatch<React.SetStateAction<ConfirmParams | null>>, ConfirmParams | null] | null;

const confirmContext = createContext<ConfirmContextState>(null);

type ConfirmProviderProps = { children: React.ReactNode };

export const useConfirm = () => {
  const context = useContext(confirmContext);

  if (!context) {
    throw new Error('useConfirm must be used within a ConfirmProvider');
  }

  return context;
};

export const ConfirmProvider = (props: ConfirmProviderProps) => {
  const [showConfirm, setShowConfirm] = useState<ConfirmParams | null>(null);

  const value = useMemo<[React.Dispatch<React.SetStateAction<ConfirmParams | null>>, ConfirmParams | null]>(
    () => [setShowConfirm, showConfirm],
    [showConfirm],
  );

  return <confirmContext.Provider value={value} {...props} />;
};
